import styles from "./MaxWidth.module.css";
export default function MaxWidth({
  children,
  className = ""
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`${styles.wrapper} ${className}`}>{children}</div>;
}